/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/generate/GenerateGuid.ts
 * @create:      2025-06-28 09:39:27.100
 * @modify:      2025-07-11 21:19:12.896
 * @version:     6.0.0
 * @times:       3
 * @lines:       61
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

/**
 * Generates a random GUID (Globally Unique Identifier) in the standard 8-4-4-4-12 hexadecimal format.
 *
 * @remarks
 * This function uses `Math.random()` to generate random values, which may not be suitable for cryptographic purposes.
 * The generated GUID conforms to version 4 UUID format.
 *
 * @returns {string} A randomly generated GUID string.
 *
 * @example
 * ```typescript
 * const guid = GenerateGuid();
 * console.log(guid); // Example output: '3f2504e0-4f89-41d3-9a0c-0305e82c3301'
 * ```
 * 
 * @version 1.0.0
 * @since 1.0.5
 */
export function GenerateGuid(): string {
    // cSpell:ignore yxxx
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0;

        const v = c === "x" ? r : (r & 0x3) | 0x8;

        return v.toString(16);
    });
}
